import { rbac } from '@utils/rbac';

export const checkRbacPermission = (permission: string): boolean => {
  const localAdmin: string | null = localStorage.getItem('admin');
  const admin = localAdmin ? JSON.parse(localAdmin) : null;

  return rbac.hasPermission(admin, permission);
};
